import { TeacherSearchResultsEffects } from './teacher-searchresults.effect';
import { TeacherDetailsEffects } from './teacher-details.effect';

export const effects: any[] = [TeacherDetailsEffects, TeacherSearchResultsEffects];

export * from './teacher-searchresults.effect';
export * from './teacher-details.effect';
